import * as api from '../../api/news'
import { moduleFactory } from '../helper'

const arr = [
  ['findAll', 'banners', 'data'],
  ['findPickTree', 'pickTree', 'data', 'categoryType'],
  ['getRandom', 'random', 'data'],
  ['findPage', 'news', 'data', 'basicCategoryid'],
  ['findSonTrees', 'sonTrees', 'data', 'parentId'],
  ['typeArticles', 'articles', 'data', 'categoryId', 'type'],
  ['articleList', 'articles', 'data', 'basicCategoryid'],
  ['getArticle', 'article', 'data'],
  ['getCategory', 'category', 'data'],
  ['fullTextSearch']
]

const cached = []

export default moduleFactory(arr, api, cached)

// console.log(moduleFactory(arr, api, cached))
